import { FC, useEffect } from 'react';
import useTitleBarSelect from '../../../../hooks/useTitleBarSelect';
import AggregateLiquidationTable from './table/ag-table.component';
import { StressLevel } from '../fundAssetLiquidationTime/table';
import { useDispatch, useSelector } from 'react-redux';
import { activeSectionSelector } from '../../../../redux/pages/selectors';
import { Select } from '../../../../types/redux/pages/PagesStore';
import {
  addAdditionalTitleBarComponents,
  removeTitleBarComponent,
} from '../../../../redux/pages/actions';
import {
  APPEND_NEW_SELECT_TO_TITLEBAR,
  REMOVE_SELECT_FROM_TITLEBAR,
} from '../../../../types/redux/pages/pageTypes';
import { GeneralOverviewPageRenderedComponentProps } from '../../../layout/general/SimpleGeneralPageWrapper';
import { QueryBoundary } from '../../../utilityComponents/QueryBoundary';
import { useAggregateLiquidationPageModel } from './queries';

export const liquidityMap: Record<string, string> = {
  standard: 'Standard',
  stressed: 'Stressed',
  superStressed: 'Super Stressed',
};
const AggregateLiquidationPage: FC<GeneralOverviewPageRenderedComponentProps> = ({
  positionDate,
}) => {
  const dispatch = useDispatch();

  // Add the select components to the title bar
  useEffect(() => {
    const selectsToAdd: Select[] = [
      {
        titleBarTitle: 'Stress Level: ',
        titleBarKey: 'stressLevel',
        values: [
          {
            label: 'Standard',
            value: 'standard',
          },
          {
            label: 'Stressed',
            value: 'stressed',
          },
          {
            label: 'Super Stressed',
            value: 'superStressed',
          },
        ],
        displayOnOverviewPage: true,
        aValueIsAlwaysSelected: true,
        currentValue: 'standard',
      },
    ];

    dispatch(
      addAdditionalTitleBarComponents(
        selectsToAdd,
        APPEND_NEW_SELECT_TO_TITLEBAR,
      ),
    );

    return () => {
      dispatch(
        removeTitleBarComponent('stressLevel', REMOVE_SELECT_FROM_TITLEBAR),
      );
    };
  }, []);

  const stressLevel = useTitleBarSelect('stressLevel');
  const activeSection = useSelector(activeSectionSelector);

  const query = useAggregateLiquidationPageModel(activeSection || undefined, positionDate);

  return (
    <QueryBoundary<any>
      isLoading={query.isLoading}
      isFetching={query.isFetching}
      isError={query.isError}
      error={query.error}
      data={query.data?.data}
      loadingMessages={['Loading aggregate liquidation data...']}
      noDataMessage="No aggregate liquidation data available."
    >
      {(pageData) => (
        <AggregateLiquidationTable
          selectedLevel={(stressLevel as StressLevel) || 'standard'}
          pageModelData={pageData}
          loading={query.isFetching}
        />
      )}
    </QueryBoundary>
  );
};

export default AggregateLiquidationPage;
